"use strict";
/**
 * 双币理财申购权限
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementStatus = exports.DualInvestStatus = exports.DualCoinType = exports.DualCoinMgrPermission = void 0;
var DualCoinMgrPermission;
(function (DualCoinMgrPermission) {
    DualCoinMgrPermission["REVIEWING"] = "REVIEWING";
    DualCoinMgrPermission["ACCEPTED"] = "ACCEPTED";
    DualCoinMgrPermission["REJECTED"] = "REJECTED";
})(DualCoinMgrPermission || (exports.DualCoinMgrPermission = DualCoinMgrPermission = {}));
/**
 * 双币理财投资类型
 */
var DualCoinType;
(function (DualCoinType) {
    DualCoinType["base"] = "DUAL_BASE";
    DualCoinType["currency"] = "DUAL_CURRENCY";
})(DualCoinType || (exports.DualCoinType = DualCoinType = {}));
//申购订单的状态
var DualInvestStatus;
(function (DualInvestStatus) {
    DualInvestStatus["CREATED"] = "CREATED";
    DualInvestStatus["SUBMITTED"] = "SUBMITTED";
    DualInvestStatus["CONFIRMED"] = "CONFIRMED";
    DualInvestStatus["FILLED"] = "FILLED";
    DualInvestStatus["PARTIAL_FILLED"] = "PARTIAL_FILLED";
    DualInvestStatus["CANCELLED"] = "CANCELLED";
    DualInvestStatus["REJECTED"] = "REJECTED";
})(DualInvestStatus || (exports.DualInvestStatus = DualInvestStatus = {}));
var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["UNSETTLED"] = "UNSETTLED";
    SettlementStatus["SETTLED"] = "SETTLED";
    SettlementStatus["PAID"] = "PAID";
})(SettlementStatus || (exports.SettlementStatus = SettlementStatus = {}));
